import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=10c65b45&scoped=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=10c65b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c65b45",
  null
  
)

export default component.exports